export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-stepper/index.js